import { render, staticRenderFns } from "./GeneralFormTab.vue?vue&type=template&id=3c223aca"
import script from "./GeneralFormTab.vue?vue&type=script&lang=js"
export * from "./GeneralFormTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports